module.exports = __webpack_public_path__ + "static/media/whatsonew.36814132.png";


//////////////////
// WEBPACK FOOTER
// ./src/whatsonew.png
// module id = 78
// module chunks = 0